import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  readonly APPLICATION_FORM_KEY: string = 'application-form';
  readonly USER_KEY: string = 'user';
  readonly HAS_ACKNOWLEDGED_APPLICATION_CHECKLIST: string =
    'has-acknowledged-application-checklist';

  constructor() {}

  clearStorage() {
    Object.values(this).forEach((value) => {
      if (typeof value === 'string') {
        localStorage.removeItem(value);
      }
    });
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }

  persist(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  retrieve(key: string): string | null {
    return localStorage.getItem(key);
  }
}
